import Download from '../component/Download'
import _get from 'lodash/get'
import { documentCenterStore } from '@/services/DocumentCenter/store'
import { parseDate } from '@/utilities/Date/parse'
import { notifyProblem, notifyWarning } from '@/services/notify'
import { govDocStore } from '@/services/GoverningDocument/store'

export const methods = {
  determineRows: async function(list) {
    if (!Array.isArray(list)) {
      return
    }

    var rows = list.map(entry => {
      const documentName = _get(entry, 'description', '')
      const createdDate = parseDate(_get(entry, ['createdDate'], ''), 'LL')

      return {
        documentName: documentName,
        uploaded: createdDate,
        document: {
          component: Download,
          props: {
            governingDocumentID: _get(entry, ['governingDocumentID'], 0),
            downloadPdf: governingDocumentID => {
              this.downloadPdf(governingDocumentID, _get(entry, 'documentURL', ''))
            }
          }
        }
      }
    })

    this.rows = rows
  },

  async downloadPdf(governingDocumentID, documentURL) {
    if (this.isDebug == true) console.debug('downloadPdf...')

    if (!governingDocumentID || governingDocumentID == undefined || !documentURL) {
      notifyProblem('There is a problem downloading this document.')
    }

    try {
      var link = document.createElement('a')
      link.download = 'download.pdf'
      link.setAttribute('download', 'download.pdf')
      link.href = documentURL
      window.open(link, '_blank')
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
      notifyWarning('There was a problem downloading the statements of account.')
    }
  },

  async loadDocumentCenter() {
    if (this.isDebug == true) console.debug('in loadDocumentCenter()...')

    await documentCenterStore
      .dispatch('getDocumentCenterList', {
        hoaID: this.currentHoaId,
        governingDocumentCategoryID:
          this.governingDocumentCategoryID > 0 ? this.governingDocumentCategoryID : null
      })
      .then(async ({ list }) => {
        await this.determineRows(list)
      })
  },

  async loadGoverningDocumentCategories() {
    await govDocStore.dispatch('getGoverningDocumentCategoryList').then(async ({ list }) => {
      if (list) {
        let docCategories = []
        docCategories = list.map(m => ({
          ...m,
          label: m.name,
          value: m.governingDocumentCategoryID
        }))

        docCategories.push({ label: 'All', value: '' })
        this.governingDocumentCategories = docCategories
      }
    })
  },

  async reload() {
    this.loading = true

    this.rows = []
    await this.loadDocumentCenter()

    await this.loadGoverningDocumentCategories()

    this.loading = false
  }
}
